import React, { useEffect, useState, useMemo, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import PopUpBetfairResults from "../../agent/components/popup-betfair-results";
import PopUpGalaxyResults from "../../agent/components/popup-galaxy-results";
import PopUpTPResults from "../../agent/components/popup-tp-results";

export default function ClientVirtualDetailsPopup() {
  const { transid } = useParams();
  const [data, setData] = useState(null);
  const [summarydata, setSummaryData] = useState(null);
  const [resultsData, setResultsData] = useState(null);
  const [catMid, setCatMid] = useState("");
  const [marketType, setMarketType] = useState("");
  const [Dealer, setDealer] = useState("");
  const [winAmount, setWinAmount] = useState(0);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    const fetchBetDetails = async () => {
      const response = await axiosInstance.get(
        `profit-loss/trans-details/${transid}`
      );

      let winAmount = response?.data.winAmount;
      let comission = response?.data.comission;
      setWinAmount(winAmount);

      if (comission > 0) {
        let obj = {};
        obj.rnr = "Commission";
        obj.rnrsid = "Commission";
        obj.amnt = 1;
        obj.result_status = "";
        obj.cashout_rate = 0 - comission;
        obj.rate = 1;
        obj.pro = comission;
        obj.type = "c";
        obj.lib = 0 - comission;
        obj.stmp = 0 - comission;
        obj.displayTxt = "Commission";
        obj.id = "00000000-0000-0000-0000-000000000000";
        obj.uname = "";
        obj.Dealer = "";

        response.data?.bet?.betList?.push(obj);
      }

      setSummaryData(response.data.bet);

      console.log(response.data);
      setData(response.data.bet.betList);
      setResultsData(response.data.bet.rateJson);
      setCatMid(response.data.bet.cat_mid);
      setMarketType(response.data.bet.market_type);
      setDealer(response.data.bet.dealer);
      setIsLoading(false);
    };
    fetchBetDetails();
  }, []);

  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);

  const loadingRef = useRef(false);
  const gridTableRef = useRef(null);
  const defaultExpand = false;

  let winnerName = "";
  let resultVal = resultsData?.result;
  if (marketType == 33 || marketType == 34) {
    if (resultVal == 1) {
      winnerName = "Hand 1";
    } else if (resultVal == 2) {
      winnerName = "Hand 2";
    } else if (resultVal == 3) {
      winnerName = "Hand 3";
    } else if (resultVal == 4) {
      winnerName = "Hand 4";
    }
  } else if (marketType == 35 || marketType == 36) {
    if (resultsData?.rnr1_status == "WINNER") {
      winnerName += "Card 1 or further" + ", ";
    }
    if (resultsData?.rnr2_status == "WINNER") {
      winnerName += "Card 2 or further" + ", ";
    }
    if (resultsData?.rnr3_status == "WINNER") {
      winnerName += "Card 3 or further" + ", ";
    }
    if (resultsData?.rnr4_status == "WINNER") {
      winnerName += "Card 4 or further" + ", ";
    }
    if (resultsData?.rnr5_status == "WINNER") {
      winnerName += "Card 5 or further" + ", ";
    }
    if (resultsData?.rnr6_status == "WINNER") {
      winnerName += "Card 6 or further" + ", ";
    }
    if (resultsData?.rnr7_status == "WINNER") {
      winnerName += "Card 7 or further" + ", ";
    }
    if (resultsData?.rnr8_status == "WINNER") {
      winnerName += "Card 8 or further" + ", ";
    }
    if (resultsData?.rnr9_status == "WINNER") {
      winnerName += "Card 9 or further" + ", ";
    }
    if (resultsData?.rnr10_status == "WINNER") {
      winnerName += "Card 10 or further" + ", ";
    }
    if (resultsData?.rnr11_status == "WINNER") {
      winnerName += "Card 11" + ", ";
    }
    if (resultsData?.rnr12_status == "WINNER") {
      winnerName += "2 Card Run" + ", ";
    }
    if (resultsData?.rnr13_status == "WINNER") {
      winnerName += "3 Card Run" + ", ";
    }
    if (resultsData?.rnr14_status == "WINNER") {
      winnerName += "4 Card Run" + ", ";
    }
    if (resultsData?.rnr15_status == "WINNER") {
      winnerName += "No Ace" + ", ";
    }
    if (resultsData?.rnr16_status == "WINNER") {
      winnerName += "No Picture Cards" + ", ";
    }
  } else if (marketType == 37 || marketType == 38) {
    if (resultsData?.rnr1_status == "WINNER") {
      winnerName += "Player 1" + ", ";
    }
    if (resultsData?.rnr2_status == "WINNER") {
      winnerName += "Player 2" + ", ";
    }
    if (resultsData?.rnr3_status == "WINNER") {
      winnerName += "Player 3" + ", ";
    }
    if (resultsData?.rnr4_status == "WINNER") {
      winnerName += "Player 4" + ", ";
    }
    if (resultsData?.rnr5_status == "WINNER") {
      winnerName += "Dealer wins or ties all" + ", ";
    }
    if (resultsData?.rnr6_status == "WINNER") {
      winnerName += "One or more has 5 cards" + ", ";
    }
    if (resultsData?.rnr7_status == "WINNER") {
      winnerName += "All cards unique" + ", ";
    }
    if (resultsData?.rnr8_status == "WINNER") {
      winnerName += "Only one has 21pts" + ", ";
    }
  } else if (marketType == 39) {
    if (resultsData?.rnr1_status == "WINNER") {
      winnerName += "Hand 1" + ", ";
    }
    if (resultsData?.rnr2_status == "WINNER") {
      winnerName += "Hand 2" + ", ";
    }
    if (resultsData?.rnr3_status == "WINNER") {
      winnerName += "Hand 3" + ", ";
    }
    if (resultsData?.rnr4_status == "WINNER") {
      winnerName += "Hand 4" + ", ";
    }
    if (resultsData?.rnr5_status == "WINNER") {
      winnerName += "Winner has FH or better" + ", ";
    }
    if (resultsData?.rnr6_status == "WINNER") {
      winnerName += "Winner has Flush" + ", ";
    }
    if (resultsData?.rnr7_status == "WINNER") {
      winnerName += "Winner has Straight" + ", ";
    }
    if (resultsData?.rnr8_status == "WINNER") {
      winnerName += "Winner has Three of a Kind" + ", ";
    }
    if (resultsData?.rnr8_status == "WINNER") {
      winnerName += "Winner has Two Pair or worse" + ", ";
    }
  } else if (marketType == 40 || marketType == 41) {
    if (resultsData?.rnr1_status == "WINNER") {
      winnerName += "Player" + ", ";
    }
    if (resultsData?.rnr2_status == "WINNER") {
      winnerName += "Banker" + ", ";
    }
    if (resultsData?.rnr3_status == "WINNER") {
      winnerName += "Tie" + ", ";
    }
    if (resultsData?.rnr4_status == "WINNER") {
      winnerName += "Pocket Pair In Any Hand" + ", ";
    }
    if (resultsData?.rnr5_status == "WINNER") {
      winnerName += "Highest Hand Has Nine" + ", ";
    }
    if (resultsData?.rnr6_status == "WINNER") {
      winnerName += "Highest Hand Is Odd" + ", ";
    }
    if (resultsData?.rnr7_status == "WINNER") {
      winnerName += "Natural Win" + ", ";
    }
    if (resultsData?.rnr8_status == "WINNER") {
      winnerName += "Natural Tie" + ", ";
    }
  } else if (marketType == 62 || marketType == 63) {
    if (resultVal == 1) {
      winnerName += "Spades";
    }
    if (resultVal == 2) {
      winnerName += "Hearts";
    }
    if (resultVal == 3) {
      winnerName += "Clubs";
    }
    if (resultVal == 4) {
      winnerName += "Diamonds";
    }
  }

  const cols = useMemo(
    () => [
      {
        title: "Runner",
        data: "rnrsid",
        responsivePriority: 1,
        render: (d, type, row, meta) => {
          let splitRnr = d.split("-");
          let runnerName = "";
          if (splitRnr == "Commission") {
            runnerName = "Commission";
          } else {
            let rnrVal = splitRnr[1];

            if (marketType == 33 || marketType == 34) {
              if (rnrVal == 1) {
                runnerName = "Hand 1";
              } else if (rnrVal == 2) {
                runnerName = "Hand 2";
              } else if (rnrVal == 3) {
                runnerName = "Hand 3";
              } else if (rnrVal == 4) {
                runnerName = "Hand 4";
              }
            } else if (marketType == 35 || marketType == 36) {
              if (rnrVal == 1) {
                runnerName = "Card 1 or further";
              } else if (rnrVal == 2) {
                runnerName = "Card 2 or further";
              } else if (rnrVal == 3) {
                runnerName = "Card 3 or further";
              } else if (rnrVal == 4) {
                runnerName = "Card 4 or further";
              } else if (rnrVal == 5) {
                runnerName = "Card 5 or further";
              } else if (rnrVal == 6) {
                runnerName = "Card 6 or further";
              } else if (rnrVal == 7) {
                runnerName = "Card 7 or further";
              } else if (rnrVal == 8) {
                runnerName = "Card 8 or further";
              } else if (rnrVal == 9) {
                runnerName = "Card 9 or further";
              } else if (rnrVal == 10) {
                runnerName = "Card 10 or further";
              } else if (rnrVal == 11) {
                runnerName = "Card 11";
              } else if (rnrVal == 12) {
                runnerName = "2 Card Run";
              } else if (rnrVal == 13) {
                runnerName = "3 Card Run";
              } else if (rnrVal == 14) {
                runnerName = "4 Card Run";
              } else if (rnrVal == 15) {
                runnerName = "No Ace";
              } else if (rnrVal == 15) {
                runnerName = "No Picture Cards";
              }
            } else if (marketType == 37 || marketType == 38) {
              if (rnrVal == 1) {
                runnerName = "Player 1";
              } else if (rnrVal == 2) {
                runnerName = "Player 2";
              } else if (rnrVal == 3) {
                runnerName = "Player 3";
              } else if (rnrVal == 4) {
                runnerName = "Player 4";
              } else if (rnrVal == 5) {
                runnerName = "Dealer wins or ties all";
              } else if (rnrVal == 6) {
                runnerName = "One or more has 5 cards";
              } else if (rnrVal == 7) {
                runnerName = "All cards unique";
              } else if (rnrVal == 8) {
                runnerName = "Only one has 21pts";
              }
            } else if (marketType == 39) {
              if (rnrVal == 1) {
                runnerName = "Hand 1";
              } else if (rnrVal == 2) {
                runnerName = "Hand 2";
              } else if (rnrVal == 3) {
                runnerName = "Hand 3";
              } else if (rnrVal == 4) {
                runnerName = "Hand 4";
              } else if (rnrVal == 5) {
                runnerName = "Winner has FH or better";
              } else if (rnrVal == 6) {
                runnerName = "Winner has Flush";
              } else if (rnrVal == 7) {
                runnerName = "Winner has Straight";
              } else if (rnrVal == 8) {
                runnerName = "Winner has Three of a Kind";
              } else if (rnrVal == 9) {
                runnerName = "Winner has Two Pair or worse";
              }
            } else if (marketType == 40 || marketType == 41) {
              if (rnrVal == 1) {
                runnerName = "Player";
              } else if (rnrVal == 2) {
                runnerName = "Banker";
              } else if (rnrVal == 3) {
                runnerName = "Tie";
              } else if (rnrVal == 4) {
                runnerName = "Pocket Pair In Any Hand";
              } else if (rnrVal == 5) {
                runnerName = "Highest Hand Has Nine";
              } else if (rnrVal == 6) {
                runnerName = "Highest Hand Is Odd";
              } else if (rnrVal == 7) {
                runnerName = "Natural Win";
              } else if (rnrVal == 8) {
                runnerName = "Natural Tie";
              }
            } else if (marketType == 62 || marketType == 63) {
              if (rnrVal == 1) {
                runnerName = "Spades";
              } else if (rnrVal == 2) {
                runnerName = "Hearts";
              } else if (rnrVal == 3) {
                runnerName = "Clubs";
              } else if (rnrVal == 4) {
                runnerName = "Diamonds";
              }
            }
          }

          return `
          <div class="d-flex align-items-center justify-content-between"> 
            <span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${runnerName}</span>
          </div>`;

          /*return `
          <div class="d-flex align-items-center justify-content-between">
            <span>${runnerName}</span>
            <button type="button" class="toggle-row toggle-closed" style="margin-left:8px;">+</button>
          </div>`;*/
        }
      },
      {
        title: "Price",
        data: "amnt",
        render: (d) =>
          d != null
            ? '<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">' +
            formatTruncate(d) +
            "</span>"
            : ""
      },
      {
        title: "Result Status",
        data: "result_status",
        visible: false
      },
      {
        title: "Size",
        data: "rate",
        render: (d) =>
          d != null
            ? '<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">' +
            d +
            "</span>"
            : ""
      },
      {
        title: "Side",
        data: "type",
        createdCell: (td, val) => {
          if (val == "c") {
            $(td).css({
              background: "#d03341",
              color: "white",
              textAlign: "left",
              fontWeight: "700",
              fontSize: "0.9rem"
            });
          } else {

            if (val == "L" || val == "l") {
              $(td).css({
                background: "#dc3545",
                color: "white",
                textAlign: "left",
                fontWeight: "700",
                fontSize: "0.9rem"
              });
            } else {
              $(td).css({
                background: "#179aaf",
                color: "white",
                textAlign: "left",
                fontWeight: "700",
                fontSize: "0.9rem"
              });
            }
          }
        },
        render: (d, type, row, meta) => {
          if (row?.type == "b") {
            return `<span style="font-size: 0.9rem;color:black" class="txt_css">B</span>`;
          } else if (row?.type == "l") {
            return `<span style="font-size: 0.9rem;color:black" class="txt_css">L</span>`;
          } else {
            return `<span class="txt_css"></span>`;
          }
        }
        //render: (d) => `<strong class="txt_css">${d}</strong>`
      },
      {
        title: "P/L",
        data: "lib",
        /*createdCell: (td, cellData, rowData) => {
          const val = rowData.type === "L" ? rowData.lib : rowData.pro;
          if (rowData.result_status == 1) {
            $(td).css({
              background: "#d1e7dd",
              color: "#0f5132",
              fontWeight: 600,
              textAlign: "right"
            });
          } else {
            $(td).css({
              background: "#f8d7da",
              color: "#842029",
              fontWeight: 600,
              textAlign: "right"
            });
          }
        },*/
        render: (d, type, row) => {
          debugger;
          let val = 0;
          if (row.type == "c") {
            val = row.lib;
            return `<span style="white-space: nowrap;font-size: 0.9rem;color:red" class="txt_css">${formatTruncate(
              val
            )}</span>`;
          } else {
            if (row.result_status && row.result_status !== 0) {
              if (row.result_status == 1) {
                if (row.type.toUpperCase() === "B") {
                } else {
                }
                val = row.pro;
                return `<span style="white-space: nowrap;font-size: 0.9rem;color:green" class="txt_css">${formatTruncate(
                  val
                )}</span>`;
              } else {
                if (row.type.toUpperCase() === "B") {
                  val = row.lib;
                } else {
                  val = row.lib;
                }

                return `<span style="white-space: nowrap;font-size: 0.9rem;color:red" class="txt_css">-${formatTruncate(
                  val
                )}</span>`;
              }
            } else {
              val = row.type.toUpperCase() === "L" ? row.lib : row.pro;
              return `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${formatTruncate(
                val
              )}</span>`;
            }

            /*if (row.type.toUpperCase() === "L") {
              val = row.lib;
            } else {
              val = row.pro;
            }*/
          }
        }
      },
      {
        title: "Placed At",
        data: "stmp",
        render: (d) =>
          `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${moment(
            d
          ).format("YYYY-MM-DD HH:mm:ss")}</span>`
      },
      {
        title: "Settled At",
        data: null,
        render: () => {
          return `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${moment(
            summarydata?.created_date
          ).format("YYYY-MM-DD HH:mm:ss")}</span>`;
        }
      },
      {
        title: "Order Id",
        data: "id",
        render: (d) =>
          `<strong style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${d ?? ""
          }</strong>`
      },
      /*{
        title: "Customer",
        data: null,
        render: () => `<strong>${summarydata?.uname ?? ""}</strong>`
      },
      {
        title: "Dealer",
        data: null,
        render: () => `<strong>${Dealer ?? ""}</strong>`
      },*/
      {
        title: "FullOdds",
        data: null,
        render: () => `
      <strong class="txt_css" style="white-space: nowrap;font-size: 0.9rem;">
        <span>440</span>@<span style="color:blue">1.02</span> -
        <span>5070</span>@<span style="color:blue">1.01</span> =
        <span>1567</span>@<span style="color:red">1.03</span> -
        <span>3476</span>@<span style="color:red">1.04</span> -
        <span>2757</span>@<span style="color:red">1.05</span>
      </strong>
    `
      },
      {
        title: "",
        data: "pro",
        visible: false,
        render: (d) =>
          `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${d}</span>`,
        responsivePriority: 3
      }
    ],
    [summarydata]
  );

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !data.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe data (only include referenced keys + seq)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (data || []).map((row, i) => {
      const out = { seq: i + 1 }; // seq is initial placeholder; will be updated after draw
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: {
          details: {
            type: "column",
            target: 0
          }
        },
        pageLength: pageSize || 10,
        lengthChange: false,
        paging: true,
        autoWidth: false,
        ordering: true,
        order: initialOrder,
        // columnDefs: [{ targets: 0, orderable: false }], // safeguard
        columnDefs: [
          {
            className: "dtr-control",
            orderable: false,
            targets: 0
          },
          {
            responsivePriority: 10000,
            targets: "_all"
          }
        ],
        //dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',
        dom: '<"dt-search"f>' + "rt" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",

        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false,
        rowCallback: function (row, data, index) {
          // Mobile breakpoint (same as your CSS media query)
          const isMobile = window.matchMedia("(max-width:640px)").matches;

          if (isMobile) {
            // single dark color for every main row on mobile
            $(row).css({
              "background-color": "#f2f2f2", // dark row background
              color: "" // light text
            });
          } else {
            // Desktop: keep zebra striping you had previously
            $(row).css({
              "background-color": index % 2 === 0 ? "" : "#ffffff",
              color: "" // let default text color apply
            });
          }
        }
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)

    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";

      hiddenCols.forEach((i) => {
        const col = dt.column(i);

        if (!col || !col.header()) return;

        const title = $(col.header()).text();
        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        // Using the same render() as parent column
        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        html += `
      <tr>
        <td style="width:40%;border-top:0;border-left:0;border-right:0;border-bottom:1px solid #eee;">
          <span style="font-weight:bold;">${title}</span> 
          ${rendered}
        </td>
      </tr>`;
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(`<table class="table table-sm mb-0">${details}</table>`)
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // Initial numbering (after initial draw)
    requestAnimationFrame(() => {
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, data, pageSize, defaultExpand, isLoading]);
  return (
    <>
      <div className="animated fadeIn site_family" style={{ margin: 0 }}>
        <div className="container-fluid p-0">
          {/* small style overrides are added below using a standard <style> element */}
          <div className="row w-100 m-0">
            <div className="col-12 p-0">
              <div className="card">
                <div className="card-header">
                  <h5 className="m-0 d-flex align-items-center site_family">
                    <span className="heading_css">{summarydata?.remark}</span>
                  </h5>
                </div>

                <div className="card-body site_family">
                  <div class="row mb-3">
                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Winner
                      <span class="badge badge-warning ml-2">{winnerName}</span>
                    </div>

                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Net PL
                      <span
                        id="win_amt"
                        className={
                          winAmount < 0
                            ? "badge badge-danger bg-danger ml-2"
                            : "badge badge-success bg-success ml-2"
                        }
                        style={{
                          fontSize: "100%",
                          color: "white",
                          padding: 4,
                          borderRadius: 4,
                          fontSize: "0.8rem"
                        }}
                      >
                        {formatTruncate(winAmount)}
                      </span>
                    </div>
                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Username
                      <span class="ml-2 badge badge-warning">
                        {" "}
                        {summarydata?.uname}
                      </span>
                    </div>
                  </div>
                  <div className="datatable-wrapper">
                    <table
                      ref={gridTableRef}
                      className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2 txt_css"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          {cols.map((c) => (
                            <th key={String(c.data || c.title)}>{c.title}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody />
                    </table>
                  </div>
                </div>

                <PopUpBetfairResults
                  resultsData={resultsData}
                  catMid={catMid}
                  marketType={marketType}
                ></PopUpBetfairResults>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SAFE CSS (no dangerouslySetInnerHTML) */}
      <style>{`

table.dataTable.no-footer {
  border-bottom: 0px solid #111;
}
.table.dataTable thead th, table.dataTable thead td{
  border-bottom: 1px solid #dee2e6;
}
.dt-paging-button { 
  padding: .5em 0px; 
}

        .table { width: 100% !important; }
        .table.table-striped td, .table.table-striped th {
          padding: 4px 8px !important;
          font-size: 16px;
          white-space: normal !important;
          vertical-align: middle;
        }
        
        .pagination {
          
          float: right;
      }
        .toggle-row {
          border: none;
          cursor: pointer;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          background:#337ab7;
          display:flex;
          align-items:center;
          justify-content:center;
          font-family: 'Courier New', Courier, monospace;
          border: 2px solid white;
          box-shadow: 0 0 3px #444;
           
        }
        .toggle-open { background:#dc3545 !important; }
        .summary-table th { text-align:left; border: 0; padding: 0.25rem 0; }
        @media (max-width: 640px) {
          .pagination {
          
            float: unset;
        }
        .dt-info {
          float: unset;
          
      }
          .summary-table th { display:block; width:100%; white-space:normal; font-size:14px; }
          .table.table-striped td, .table.table-striped th { font-size:14px !important; padding:6px 6px !important; }
        }
        .heading_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          margin-bottom: .5rem;
          line-height: 1.2;
          font-size: 1.5rem;
          font-weight: 500;
          padding: .75rem 1.25rem;
         
        }

        .txt_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        }



        table.dataTable.dtr-inline.collapsed tbody tr td.dtr-control:before,
        table.dataTable.dtr-inline.collapsed tbody tr th.dtr-control:before 
        {
          height: 14px;
    width: 14px;
    margin-right: .5em;
    display: inline-block;
    content: "+";
    color: white;
    border: 2px solid white;
    border-radius: 14px;
    box-shadow: 0 0 3px #444;
    box-sizing: content-box;
    text-align: center;
    text-indent: 0 !important;
    font-family: 'Courier New', Courier, monospace;
    line-height: 14px;
    background-color: #337ab7;
    float: inline-start;
           
        }
        div.dt-container .dt-paging .dt-paging-button {
          padding: 4px 0px;
        }

        div.dt-container .dt-paging .dt-paging-button:hover {
          /* color: white !important; */
          border: 0px solid #111;
          background-color: transparent
          background: unset;
      }

/* Open row */
table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > td.dtr-control:before, table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > th.dtr-control:before {
  content: '-';
  background-color: #d33333;
  border: 2px solid white;
  float: inline-start;
}
      `}</style>
    </>
  );
}
